import React from "react";
import { Link } from "react-router-dom";
import { Gift, ShieldAlert } from "lucide-react";
import { ASSETS } from "@/lib/assets";

export default function Rewards() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-16 text-center">
      <img src={ASSETS.pointing} alt="rewards" className="w-40 mx-auto animate-floaty" />
      <span className="tag mt-4 inline-block">Coming Soon</span>
      <h1 className="headline text-cream text-4xl sm:text-5xl mt-4">ROBBED <span className="text-neon">REWARDS</span></h1>
      <p className="font-mono text-dim mt-4 max-w-xl mx-auto">
        Community rewards, meme-battle prizes and airdrops will launch here after $ROBBED goes live on-chain.
        Link your wallets now so you're ready.
      </p>
      <div className="comic-card p-5 mt-8 flex items-start gap-3 text-left bg-[#0f1a0f]">
        <ShieldAlert className="w-6 h-6 text-neon shrink-0" />
        <p className="font-mono text-[12px] text-dim leading-relaxed">
          No rewards, eligibility or balances are fabricated. Nothing is claimable yet. Always verify the official
          contract or mint on robbedcoin.com before interacting with anything claiming to be $ROBBED.
        </p>
      </div>
      <div className="flex justify-center gap-3 mt-8">
        <Link to="/settings" className="btn-neon"><Gift className="w-4 h-4" /> Link A Wallet</Link>
        <Link to="/memes" className="btn-ghost">Make A Meme</Link>
      </div>
    </div>
  );
}
